module.exports = __webpack_public_path__ + "/login_ui/img/id-44624bd29c7aca2d4216108be86bf396.svg";